// components/SubmittedFormCard.jsx
import React from 'react';
import { useState,useEffect } from "react";

import DeleteConfirmation from './ConfirmDelete';
const SubmittedFormCard = ({
  item,
  handleAllowResubmit,
}) => {
     const [showModal, setShowModal] = useState(false);
          
        
  return (
    <div className="w-[400px]  bg-white shadow-md rounded-2xl p-4 border border-gray-200 mt-4">
      <h2 className="text-xl font-semibold text-gray-800">
        Semester: {item.semester}
      </h2>
      <p className="text-gray-600">Name: {item.name}</p>
      <p className="text-gray-600">Roll No: {item.rollno}</p>
      <p className="text-gray-600">Session: {item.session}</p>
      <button
        onClick={() =>
         setShowModal(true)
        }
        className="mt-3 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        ALLOW RESUBMIT
      </button>
<div className='w-full bg-red-300'><DeleteConfirmation
        isOpen={showModal}
        onCancel={() => setShowModal(false)}
        onDelete={() => {
          setShowModal(false);
           handleAllowResubmit(item.semester, item.session, item.rollno)
        }}
        confirmButtonName="ALLOW"
   message="Are you sure you want to allow the student to do changes in the formFillup details?Please click cancel if not sure."
 
      /></div>
      
    </div>
  );
};

export default SubmittedFormCard;
